import { Component, input } from '@angular/core';

@Component({
    selector: 'fb-empty-state',
    template: `
        <div class="flex flex-col items-center justify-center text-center gap-3 py-16 px-6">
            <span class="size-10 flex items-center justify-center rounded-full bg-concern-accent text-concern-accent-dot text-2xl">
                <i [class]="'ph ' + icon()"></i>
            </span>
            <p class="font-display font-semibold text-lg text-text">{{ title() }}</p>
            @if (text()) {
                <p class="text-sm text-text-muted max-w-md">{{ text() }}</p>
            }
            <ng-content />
        </div>
    `
})
export class EmptyStateComponent {
    icon = input<string>('ph-tray');
    title = input.required<string>();
    text = input<string>();
}
